module.exports = __webpack_public_path__ + "img/ceiling.f2d28471.svg";